import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/sidenav/sidenav-item.component.js'

const tagName = 'dap-ds-sidenav-item'

/**
 * `dap-ds-sidenav-item`
 * @summary Side navigation item
 * @element dap-ds-sidenav-item
 * @title - Side navigation item
 * @group side-navigation
 *
 * @slot - The content of the side navigation item.
 * @slot suffix - The suffix of the side navigation item.
 *
 * @csspart base - The main side navigation item container.
 * @csspart link - The link of the side navigation item.
 *
 * @cssproperty --dds-sidenav-item-min-height-xs - Minimum height of the sidenav item.
 * @cssproperty --dds-sidenav-item-min-height-sm - Minimum height of the sidenav item.
 * @cssproperty --dds-sidenav-item-min-height-lg - Minimum height of the sidenav item.
 * @cssproperty --dds-sidenav-item-margin-bottom - Default bottom margin of the sidenav item.
 * @cssproperty --dds-sidenav-item-padding-xs - Padding of the sidenav item.
 * @cssproperty --dds-sidenav-item-padding-sm - Padding of the sidenav item.
 * @cssproperty --dds-sidenav-item-padding-lg - Padding of the sidenav item.
 * @cssproperty --dds-sidenav-item-radius - Border radius of the sidenav item.
 * @cssproperty --dds-sidenav-item-color - Text color of the sidenav item.
 * @cssproperty --dds-sidenav-item-font-size-xs - Font size of the sidenav item.
 * @cssproperty --dds-sidenav-item-font-size-sm - Font size of the sidenav item.
 * @cssproperty --dds-sidenav-item-font-size-lg - Font size of the sidenav item.
 * @cssproperty --dds-sidenav-item-font-weight - Font weight of the sidenav item.
 * @cssproperty --dds-sidenav-item-spacing-margin - Margin used for spacing variants.
 * @cssproperty --dds-sidenav-item-bg-active - Background color when the item is active.
 * @cssproperty --dds-sidenav-item-bg-hover - Background color on hover and active states.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSSideNavItem',
})

export default reactWrapper
